// @core/api/endpoints/team/create_team_avatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTeamAvatarRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Upload team avatar
 * Uploads a new avatar image for the team. The avatar is stored and can be set as the active team image.
 */
export async function CreateTeamAvatar(
  team_id: string,
  data: CreateTeamAvatarRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/avatars`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
